import React, { ReactNode, useEffect, useMemo, useState } from "react";
import AccessibilityBar from "../../../consulta-acessibilidade/AccessibilityBar";
import SuggestionsAndLinks from "../../components/mobile/SuggestionsAndLinks";
import { useAppContext } from "../../../../shared/contexts/AppContextProvider";
import {
  faBars,
  faCogs,
  faComments,
  faNewspaper,
  faQuestion,
  faSyncAlt,
  faTimes,
  faUser,
  faUserLock,
} from "@fortawesome/free-solid-svg-icons";
import SearchBar from "../../components/SearchBar/SearchBar";
import { connect } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import Faqs from "../../components/mobile/Faqs";
import {
  MobileButton,
  MobileButtonOrganizer,
} from "../../components/mobile/styles/MobileStyles";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "react-i18next";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import GuiasConteudoPersonalizado from "../../components/BaseTemplate/GuiasConteudoPersonalizado";
import Secoes from "../../components/Home/Secoes";
import { ConsultaHelper } from "../../../../shared/helpers";
import {
  Footer,
  ModalConstructor,
  SpinnerConstructor,
} from "../../../../shared/components";
import { useAppMobileContext } from "../../../../shared/contexts/AppMobileCommunicationContext";
import { Col, Row } from "reactstrap";

interface MobileLayoutProps {
  guiaSelecionada: string;
  opcoesConsultaRx: any;
  children: ReactNode;
  consultaRx: any;
  loadingRx: boolean;
  userSessionRx: any;
  userLocalRx: any;
  showSearchBar?: boolean;
}
const MobileLayout: React.FC<MobileLayoutProps> = (props) => {
  const [isClassToggled, setIsClassToggled] = useState(false);
 
  const {
    guiaSelecionada,
    opcoesConsultaRx,
    children,
    consultaRx,
    loadingRx,
    userSessionRx,
    userLocalRx,
    showSearchBar = true,
  } = props;
  const {
    setOnGoBackMobile,
    mobileView,
    setMobileView,
    faqsData,
    serviceData,
    sectionsData
  } = useAppContext();
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  const { renderedByApp } = useAppMobileContext();

  const user = userSessionRx || userLocalRx;

  useEffect(() => {
    if (loadingRx) {
      return;
    }

    const hasOpenModal = !!document.querySelector('.modal.show');
    if (hasOpenModal) {
      return;
    }

    // Defensive cleanup for stale modal scroll lock after route/search updates.
    document.body.classList.remove('modal-open');
    document.body.style.removeProperty('overflow');
    document.body.style.removeProperty('padding-right');
    document.documentElement.style.removeProperty('overflow');

    document.querySelectorAll('.modal-backdrop').forEach(backdrop => {
      backdrop.parentNode?.removeChild(backdrop);
    });
  }, [loadingRx, location.pathname, location.search]);

  useEffect(() => {
    setOnGoBackMobile(() => {
      return () => {
        setMobileView(null);
      };
    });

    return () => {
      setOnGoBackMobile(null);
    };
  }, [setOnGoBackMobile]);

   // Função para alternar a classe
  const handleToggleClass = () => {
    setIsClassToggled((prevState) => !prevState);
  };

  const handleGoToLogin = () =>{
        navigate({
            pathname: '/login',
            search: `?mobileView=login&redirect=${window.location.pathname + encodeURIComponent(window.location.search)}`
        });
    }

  const getPesquisa = () => {
    return (
      <>
        {/* @ts-ignore */}
        <ModalConstructor open={loadingRx} size="xs">
          <div className="p-4 text-center">
            {loadingRx && (
              <div>
                <SpinnerConstructor
                  visible
                  height={60}
                  width={60}
                  className="apergamum"
                />
                <div className="mt-3">
                  <span className="preto70 s17 f400">
                    {t("PesquisandoAguarde")}
                  </span>
                </div>
              </div>
            )}
          </div>
        </ModalConstructor>
        {showSearchBar && (
          consultaRx?.data?.length > 0 ? (
            <div className="fixoMobileBtn">
              <MobileButton
                className="btn-generic--segundo ml-0 btn-responsivo"
                onClick={() => {
                  ConsultaHelper.limparConsulta();
                }}
              >
                <FontAwesomeIcon
                  icon={faSyncAlt as IconProp}
                  className="icone-header mr-2"
                />
                {t("MobileLayout.RefazerPesquisa")}
              </MobileButton>
            </div>
          ) : (
            <SearchBar
              opcoesConsulta={opcoesConsultaRx}
              guiaSelecionada={guiaSelecionada}
            />
          )
        )}

        {children}

        <Footer showLinks />
      </>
    );
  };

  const getContent = () => {
    switch (mobileView) {
      case "suggestions_and_links":
        return <SuggestionsAndLinks />;
      case "search":
        return getPesquisa();
      case "faqs":
        return <Faqs />;
      case "services":
        return <GuiasConteudoPersonalizado />;
      case "featured_and_news":
        return sectionsData && sectionsData?.length > 0 ? (
          <Secoes secoes={sectionsData} guiaSelecionada={guiaSelecionada} />
        ) : (
          ""
        );
      default:
        null;
    }
  };

  return (
    <div>
      {!renderedByApp && <AccessibilityBar /> }
      {[null, "login"].includes(mobileView) ? (
        <>
          <div className="hmobile">{getPesquisa()}</div>
          <div
            className={`secaoBtnMobileHome js-posicao1 ${isClassToggled ? "js-posicao2" : " "}`}
          >
            <div className="px-2 py-3">
              { renderedByApp ? (
                  <button
                    type="button"
                    className="btn-mobile-footer--segundo ml-0 btn-responsivo"
                    onClick={handleToggleClass}
                  >
                    <FontAwesomeIcon
                      className="s16 mr-1"
                      icon={faBars as IconProp}
                    />
                    {t('VerMais')}
                  </button>
                ):(
                  <Row className='w-100'>
                    <Col xs='6'>
                        <button
                            type='button'
                            className='w-100 btn-mobile-footer--segundo btn-responsivo' onClick={handleToggleClass}>
                            <FontAwesomeIcon className='s16 mr-1' icon={faBars as IconProp}/>
                            {t('VerMais')}
                        </button>
                    </Col>
                    <Col xs='6'>
                        <button
                            type='button'
                            className='w-100 btn-mobile-footer--primeiro ml-0 btn-responsivo'
                                onClick={() => handleGoToLogin()}>
                            <FontAwesomeIcon className='s16 mr-1' icon={faUserLock as IconProp}/>
                            {t('Entrar')}
                        </button>
                    </Col>
                </Row>
              )} 
            </div>
          </div>
          <div className={`js-bgBlock  ${isClassToggled ? "" : "d-none "}`} />
          <div
            className={`secaoBtnMobileHome js-posicao2 ${isClassToggled ? "js-posicao1" : " "}`}
          >
            <MobileButtonOrganizer className="px-3 py-4">
              <button
                type="button"
                className="btn-mobile-footer--segundo mb-4 ml-0"
                onClick={handleToggleClass}
              >
                <FontAwesomeIcon
                  className="s16 mr-1"
                  icon={faTimes as IconProp}
                />
                {t('Fechar')}
              </button>
              {user ? (
                <MobileButton
                  className="altura btn-mobile-footer--primeiro ml-0 btn-responsivo"
                  onClick={() => {
                    navigate({
                      pathname: "/meupergamum",
                      search: `?mobileView=meupergamum=${window.location.pathname + encodeURIComponent(window.location.search)}`,
                    });
                  }}
                >
                  <FontAwesomeIcon
                    className="s16 mr-1"
                    icon={faUser as IconProp}
                  />
                  {t("Meu Pergamum")}
                </MobileButton>
              ) : (
                <MobileButton
                  className="altura btn-mobile-footer--primeiro ml-0 btn-responsivo"
                  onClick={() => handleGoToLogin()}
                >
                  <FontAwesomeIcon
                    className="s16 mr-1"
                    icon={faUserLock as IconProp}
                  />
                  {t("Entrar")}
                </MobileButton>
              )}
              {serviceData !== null && serviceData.length > 0 && (
                <MobileButton
                  className="altura btn-mobile-footer--segundo ml-0"
                  onClick={() => {
                    setMobileView("services");
                  }}
                >
                  <FontAwesomeIcon
                    className="s16 mr-1"
                    icon={faCogs as IconProp}
                  />
                  {t("MobileLayout.Atendimento")}
                </MobileButton>
              )}
              {faqsData !== null && faqsData.length > 0 && (
                <MobileButton
                  className="altura btn-mobile-footer--segundo ml-0"
                  onClick={() => {
                    setMobileView("faqs");
                  }}
                >
                  <FontAwesomeIcon
                    className="s16 mr-1"
                    icon={faQuestion as IconProp}
                  />
                  {t("DuvidasFrequentes")}
                </MobileButton>
              )}
              <MobileButton
                className="altura btn-mobile-footer--segundo ml-0"
                onClick={() => {
                  setMobileView("suggestions_and_links");
                }}
              >
                <FontAwesomeIcon
                  className="s16 mr-1"
                  icon={faComments as IconProp}
                />
                {t("MobileLayout.LinksESugestoes")}
              </MobileButton>

              {sectionsData !== null && sectionsData?.length > 0 &&(
                <MobileButton
                  className="altura btn-mobile-footer--segundo ml-0"
                  onClick={() => {
                    setMobileView("featured_and_news");
                  }}
                >
                  <FontAwesomeIcon
                    className="s16 mr-1"
                    icon={faNewspaper as IconProp}
                  />
                  {t("MobileLayout.DestaquesENoticias")}
                </MobileButton>
              )}
            </MobileButtonOrganizer>
          </div>
        </>
      ) : (
        getContent()
      )}
    </div>
  );
};

const mapStateToProps = (state: any) => ({
  instituicaoRx: state.instituicao.data,
  opcoesConsultaRx: state.pesquisa.opcoesConsulta,
  consultaRx: state.pesquisa.consulta,
  loadingRx: state.pageConfig.loading,
  userSessionRx: state.auth.user,
  userLocalRx: state.authPersist.user,
});

export default connect(mapStateToProps)(MobileLayout);
